<template>
	<tr style="width: 100%; height: auto; display: flex; justify-content: space-between; align-items: stretch;">
		<th class="px-0" :style="'display: flex; align-items: center; justify-content: space-between; min-width: 125px; height: auto;' + (type == 0 ?'height: auto;' : 'min-height: 75px;')">
			<v-tooltip 
			color="#000000" 
			right>
				<template v-slot:activator="{ on, attrs }">
					<div 
					v-bind="attrs" 
					v-on="on" 
					style="margin: 0px; padding: 0px; height: 100%; border-right: 1px solid rgb(221, 221, 221); display: flex; justify-content: space-between; align-items: center; width: 100%;">
						<img 
						:src="getProfileAssetUrl(data.employee.profilePicture)" 
						style="object-fit: cover; margin: 4px; width: 40px; height: 40px; float: left;" />
						<div style="width: 100%; display: inline-flex; align-items: center; float: left; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; padding-right: 4px;">
							<span style="font-weight: 400;">{{ profileFullName() }}</span>
						</div>
					</div>
				</template>
				<span>{{ profileFullName() }}</span>
			</v-tooltip>
		</th>
		<th class="px-0" v-for="(calendar, index) in data.calendar" :key="calendar.id" style="height: auto; width: 100%;">
				<CalendarDay
					:index="index"
					:type="type" 
					:data="calendar" 
					:employee="data.employee" 
					:vacation="data.vacation"
					:requests="data.requests"
					:onlyVacationData="onlyVacationData"  
					:calendars="calendars" 
					:projects="projects" 
				@show-menu="onShowMenu($event)"
				@show-tooltip="onShowToolTip($event)"
				@hide-tooltip="$emit('hide-tooltip')" 
				@day-selected="$emit('day-selected', $event)" />
		</th>
		<th v-if="showSummary" v-html="buildSummaryHtml()" class="px-0 text-center" style="border-right: 1px solid #ddd; height: 100%; text-align: center; font-weight: 300; cursor: pointer;">
		</th>
	</tr>
</template>

<script>
import CalendarDayFactory from './CalendarDayFactory.js';
import CalendarDay from './CalendarDay.vue';

export default {
	name: 'CalendarRow',
	mixins: [CalendarDayFactory],
	props: ['type', 'data', 'onlyVacationData', 'showSummary', 'calendars', 'projects'],
	components: {
		CalendarDay
	},
	data () {
		return {
		}
	},
	methods: {
		onShowMenu(data) {
			//Obtenemos el HTMLElement del día a traves del index (index 0 es el HTMLElement de los datos del trabajador)
			const el = this.$el.childNodes[data.index + 1];
			const rect = el.getBoundingClientRect();
			let left = rect.left;
			let top = rect.bottom;			
			const width = rect.width;

			const menuRight = left + 248.39;

			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
			const limitH = vw * 0.80;

			if (menuRight > limitH) {
				left -= (248.39 - width);
			}
				
			const info = {
				x: left,
				y: top, 
				day: data.day
			};

			this.$emit('show-menu', info);
		},
		onShowToolTip(data) {
			//Obtenemos el HTMLElement del día a traves del index (index 0 es el HTMLElement de los datos del trabajador)
			const el = this.$el.childNodes[data.index + 1];
			const rect = el.getBoundingClientRect();
			const left = rect.left + rect.width / 2;
			const top = rect.bottom;
				
			const info = {
				x: left,
				y: top, 
				text: data.text
			};

			this.$emit('show-tooltip', info);
		},
		profileFullName() {
			if (!this.data.employee) {
				return '';
			}

			return `${this.data.employee.lastname}, ${this.data.employee.firstname}`;
		},
	}
}
</script>
